/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.7.0",
  "gitBuildTime": "2026-06-08T15:08:50.647Z",
  "gitBuildVersion": "1.7.0",
  "gitCommitId": "af1c3a6",
  "gitCommitIdFull": "af1c3a6d52538446e8133b040a693169f5f62d49",
  "gitCommitTime": "2026-06-08T15:07:21.000Z",
  "version": "1.7.0-2026-06-08T15:07:21.000Z-(af1c3a6)"
};
